// extracted by mini-css-extract-plugin
module.exports = {"container":"AddressItem_container__3vou4","root":"AddressItem_root__8BbI5","item":"AddressItem_item__tu1j3"};